// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9510c340","455":"08635dbb","946":"d48ffb99"}[chunkId] + ".chunk.js";
};